import { useCallback, useLayoutEffect, useRef, useState } from "react";

/**
 * Sliding underline indicator for a drawer's animated tab strip. Tracks the
 * active tab button's offset/width so the indicator can be positioned via
 * `transform: translateX(...)`. Single source for the `tabButtonRefs` +
 * `indicator` state duplicated across the Org, Person, and Role drawers.
 */
export function useTabIndicator(activeIndex: number) {
  const tabButtonRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  useLayoutEffect(() => {
    const el = tabButtonRefs.current[activeIndex];
    if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth });
  }, [activeIndex]);

  const registerTabRef = useCallback(
    (index: number) => (el: HTMLButtonElement | null) => {
      tabButtonRefs.current[index] = el;
    },
    [],
  );

  return { indicator, registerTabRef };
}
